// extracted by mini-css-extract-plugin
module.exports = {"phoneWrapper":"style_phoneWrapper__rT0Ux","phoneError":"style_phoneError__bqx3t"};